type Palette = { [key: string]: string };

export type BaseColors = {
  black: string;
  dark1: string;
  dark2: string;
  dark3: string;
  gray1: string;
  gray2: string;
  gray3: string;
  gray4: string;
  gray5: string;
  gray6: string;
  gray7: string;
  gray8: string;
  gray9: string;
  gray10: string;
  gray11: string;
  white: string;
  blue1: string;
  blue2: string;
  blue3: string;
  green: string;
  red1: string;
  red2: string;
  red3: string;
  orange: string;
  yellow: string;
  redDarkText: string;
};

const baseColors: BaseColors = {
  dark1: '#0b0c0e',
  dark2: '#141419',
  dark3: '#212124',
  gray1: '#343b40',
  gray2: '#acacac',
  gray3: '#acb2be',
  gray4: '#c7d0d9',
  gray5: '#aeaebc',
  gray6: '#9fa7b3',
  gray7: '#6f6f77',
  gray8: '#aeafb5',
  gray9: '#f4f4f6',
  gray10: '#ccccdc',
  gray11: '#24292e',
  blue1: '#1451ae',
  blue2: '#4279cd',
  blue3: '#538ade',
  green: '#77bf69',
  red1: '#f395a0',
  red2: '#e02f44',
  red3: '#E0226E',
  orange: '#fda362ff',
  yellow: '#f5b73d',
  white: '#FFFFFF',
  black: '#000000',
  redDarkText: '#D10E5C',
};

export const palette: Palette = {
  ...baseColors,

  gray25: '#2c3235',
  gray15: '#22252b', //'#202226',
  gray12: '#181b1f', // old '#141619',
  gray05: '#111217', // old '#0b0c0e',

  // new from figma,
  darkLayer0: '#18181A',
  darkLayer1: '#212124',
  darkLayer2: '#2a2a2f', // figma used #34343B but a bit too bright

  darkBorder1: '#34343B',
  darkBorder2: '#64646B',

  // Dashboard bg / layer 0 (light theme)
  gray90: '#F4F5F5',
  // Card bg / layer 1
  gray100: '#F4F5F5',
  // divider line
  gray80: '#D0D1D3',
  // from figma
  lightBorder1: '#E4E7E7',

  blueDarkMain: '#3D71D9', // '#4165F5',
  blueDarkText: '#6E9FFF', // '#58a6ff', //'#33a2e5', // '#5790FF',
  redDarkMain: '#D10E5C',
  greenDarkMain: '#1A7F4B',
  greenDarkText: '#6CCF8E',
  orangeDarkMain: '#FF9900',
  orangeDarkText: '#fbad37',

  blueLightMain: '#3871DC',
  blueLightText: '#1F62E0',
  blueLightMainHover: '#2c5ab0',
  redLightMain: '#E0226E',
  redLightText: '#CF0E5B',
  greenLightMain: '#1B855E',
  greenLightText: '#0A764E',
  orangeLightMain: '#FF9900',
  orangeLightText: '#B5510D',
};
